module.exports = __webpack_public_path__ + "img/the-white-princess.067d03aa.png";